import { render, staticRenderFns } from "./AccountSettingsStep.vue?vue&type=template&id=cd40ff48&scoped=true"
import script from "./AccountSettingsStep.vue?vue&type=script&lang=js"
export * from "./AccountSettingsStep.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsStep.vue?vue&type=style&index=0&id=cd40ff48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40ff48",
  null
  
)

export default component.exports